import React, {PropTypes} from 'react';
import {List, ListItem} from 'material-ui/List';
import {Link} from 'react-router';
import {FloatingActionButton, IconButton, Divider, Avatar} from 'material-ui';
import IconUpdate from 'material-ui/svg-icons/editor/mode-edit';
import IconDelete from 'material-ui/svg-icons/action/delete';
import AddIcon from 'material-ui/svg-icons/content/add';
import moment from 'moment';

import {
    blueGrey900,
    red500,
    blue500,
    white
} from 'material-ui/styles/colors';

const TaskList = ({tasks, selectedTimeSheet, onDeleteTask}) => {
    const twoDigits = (n) => (n > 9 ? "" + n: "0" + n);
    let duration = moment.duration();
    for(let index in tasks){
        duration.add(tasks[index].duration);
    }
    const totalTime = duration.hours()+'h'+twoDigits(duration.minutes());
    const tasksNodes = tasks.map((task) => {
        const duration = moment.duration(task.duration);
        const deleteTask = () => onDeleteTask(task);
        return (
            <div key={task.id}>
                <ListItem
                    leftAvatar={<Avatar backgroundColor={blueGrey900} color={white} style={{fontSize: 15}}
                                        size={50}>{duration.hours()}h{twoDigits(duration.minutes())}</Avatar>}
                    primaryText={task.project.name}
                    secondaryText={task.type.name}
                    disabled
                    rightIconButton={<div>
                        <Link to={'/timeSheet/'+task.date+'/edit/'+task.id}><IconButton iconStyle={{color: blue500}}><IconUpdate /></IconButton></Link>
                        <a href="javascript:void(0);" onClick={deleteTask}><IconButton iconStyle={{color: red500}}><IconDelete /></IconButton></a>
                    </div>}
                />
                <Divider/>
            </div>)
    });
    const newTaskLink = "/timeSheet/" + selectedTimeSheet.date + "/new";
    const rightIcon = (<Link to={newTaskLink}><IconButton iconStyle={{color: white}}><AddIcon /></IconButton></Link>);
    const title = "Liste des tâches (Temps total : "+totalTime+")";
    return (
        <div style={{maxWidth: 800}}>
            <List>
                <ListItem primaryText={title} rightIconButton={rightIcon} disabled
                          style={{backgroundColor: blueGrey900, color: white}}/>
                {tasksNodes}
            </List>
        </div>
    );
};

TaskList.propTypes = {
    tasks: PropTypes.array,
    selectedTimeSheet: PropTypes.object,
    onDeleteTask: PropTypes.func
};

export default TaskList;


/** WEBPACK FOOTER **
 ** ./src/components/TaskManager/TaskList.js
 **/